import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
// import Banner from "./components/Banner";
import About from "./components/About";
import Impact from "./components/Impact";
// import MapChart from "./components/MapChart";
import GetInvolved from "../Funder/components/GetInvolved";
import Focus from "./components/Focus";
import Philosophy from "./components/Philosophy";
import Faqs from "./components/Faqs";

const Home = () => {
  return (
    <Box>
      <Helmet>
        <title> Homepage | The African Innovation and Resilience Fund</title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        sx={{
          backgroundColor: "#fff",
          padding: "10px 0px",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
          <Header />
        </Container>
      </AppBar>
      {/* <Box bgcolor={"#EBF4F6"}>
        <Banner />
      </Box> */}
      <Box bgcolor={"#EBF4F6"}>
        <Container>
          <About />
        </Container>
      </Box>
      <Box bgcolor={"#39484E"}>
        <Container>
          <Impact />
        </Container>
      </Box>
      <Box bgcolor={"#EBF4F6"}>
        <Container>
          <Focus />
        </Container>
      </Box>
      {/* <Box bgcolor={"#fff"}>
        <MapChart />
        </Box> */}
      <Box bgcolor={"#fff"} padding={{ xs: "10% 0%", sm: "2% 0% 0% 0%" }}>
        <Container>
          <GetInvolved />
        </Container>
      </Box>
      <Box bgcolor={"#F6F4F0"}>
        <Container>
          <Philosophy />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <Faqs />
        </Container>
      </Box>
      <Box bgcolor={"#39484E"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
